import { Link, graphql, StaticQuery } from "gatsby";
import * as React from "react";
import HeaderMenu from "./HeaderMenu/HeaderMenu";
import SidebarMenu from "./SidebarMenu/SidebarMenu";
import { Dropdown, Segment, Icon, Container, Sidebar } from "semantic-ui-react";
import "../css/styles.css";
import "../css/responsive.css";
import "semantic-ui-less/semantic.less";
import "prismjs/themes/prism-okaidia.css";
import { Provider } from "react-redux";
import { store } from "../store";
import { ContentfulCourseConnection } from "../graphql-types";

export const menuItems = [
//  { name: "Home", path: "/", exact: true, icon: "home", inverted: true },
  { name: "Home", path: "/", exact: true, icon: "info circle" },
  { name: "Research", path: "/research", exact: true, icon: "book" },
];

export interface LayoutProps {
  location: {
    pathname: string;
  };
  data: {
    courses: ContentfulCourseConnection;
  };
  children: any;
}

const LayoutQuery = (props) => (
  <StaticQuery
  query={graphql`
    query {
      courses: allContentfulCourse(
        sort: { fields: courseNumber }) {
        edges {
          node {
            current
            archiveOnSite
            courseNumber
            fields {
              slug
              sylSlug
              assnSlug
              resourceSlug
            }
          }
        }
      }
    }
  `}
  render={(data) => <Layout data={data} {...props} />}
/>
);

const Layout = (props: LayoutProps) => {
  const { pathname } = props.location;
  const isHome = pathname === "/";

  const courses = props.data.courses.edges.map((e) => e.node);
  const fullCourses = courses.filter(function(course) {return course.current == true && course.archiveOnSite == false;});
  const archiveCourses = courses.filter(function(course) {return course.archiveOnSite == true;})
  const courseItems = fullCourses.map((course) => {
    const subMenu = (active: boolean) =>
      <Dropdown simple item text={course.courseNumber} className="link item mobile hidden">
        <Dropdown.Menu active={active} style={{marginTop: 0}} >
          <Dropdown.Item as={Link} to={course.fields.slug}>Course page</Dropdown.Item>
          <Dropdown.Item as={Link} to={course.fields.sylSlug}>Syllabus</Dropdown.Item>
          <Dropdown.Item as={Link} to={course.fields.assnSlug}>Assignments</Dropdown.Item>
          <Dropdown.Item as={Link} to={course.fields.resourceSlug}>Resources</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>;
    return {
      component: subMenu,
      exact: false,
      icon: "graduation cap",
      name: course.courseNumber,
      path: `${course.fields.slug}`,
    }; });
    const archiveItems = archiveCourses.map((course) =>  {
      return <Dropdown.Item as={Link} to={course.fields.slug}>{course.courseNumber}</Dropdown.Item>;
    });
    const archiveMenu = (archiveItems.length == 0) ? {} : {
        component: active => <Dropdown simple item text="Archived Courses" className="link item mobile hidden">
          <Dropdown.Menu active={active} style={{marginTop: 0}}>
            {archiveItems}
          </Dropdown.Menu>
        </Dropdown>,
        exact: false,
        name: "Test",
        icon: "graduation cap",
        path: "/archive"
      };
  return (
    <Provider store={store}>
      <Sidebar.Pushable as={Segment}>

        <SidebarMenu Link={Link} pathname={pathname} items={menuItems.concat(courseItems).concat(archiveMenu)} visible={false} />

        <Sidebar.Pusher style={{ minHeight: "100vh" }}>
          {/* Header */}

          <HeaderMenu
            Link={Link}
            pathname={pathname}
            items={menuItems.concat(courseItems).concat(archiveMenu)}
          />

          {/* Render children pages */}
          <div style={{ paddingBottom: 60 }}>
            {props.children}
          </div>

          {/* Footer */}
          <Segment inverted vertical style={{ position: "absolute", bottom: 0, width: "100%" }}>
            <Container textAlign="center">
              <p><Icon name="copyright" /> 2018 &mdash; Stephanie Schwartz 
              &mdash; <a href="http://millersville.edu">Millersville University</a></p>
            </Container>
          </Segment>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    </Provider>
  );
};

export const withLayout = <P extends object>(WrappedComponent: React.ComponentType<P>) =>
  class WithLayout extends React.Component<P & LayoutProps> {
    render() {
      return (
        <LayoutQuery location={this.props.location}>
          <WrappedComponent {...this.props} />
        </LayoutQuery>
      );
    }
  };
